$(function() {

  
  prescriptionModule._init()


  //Quantity
  $(".prescription-module-table-quantity-minus").on("click", function() {
    let $input = $(this).siblings("input[type=number]");
    let value = parseInt($input.val()) || 0;
    if (value > 0) {
      $input.val(value - 1).trigger("change");
    }
  });

  $(".prescription-module-table-quantity-plus").on("click", function() {
    let $input = $(this).siblings("input[type=number]");
    let value = parseInt($input.val()) || 0;
    $input.val(value + 1).trigger("change");
  });

})


var prescriptionModule = {

  _init: function() {
    this._bindEvents()
  },

  _bindEvents: function() {

    // Add To Cart
    $('.product-form__submit').on('click', function(e) {
      e.preventDefault();

      const $button = $(this);
      const $form = $button.closest('form');
      const isPrescriptionProduct = $button.closest('.prescription-module-wrapper').length > 0;

      if (isPrescriptionProduct) {
        if ($(".prescription-confirmation-wrapper input").is(":checked")) {
          prescriptionModule._onFormSubmit();
        } else {
          prescriptionModule._confirmationError(true);
        }
      } else {
        prescriptionModule._onNormalProductSubmit($form, $button);
      }
    });

    // Confirmation
    $(".prescription-confirmation-wrapper input").on("change", function() {
      if ($(this).is(":checked")) {
        prescriptionModule._confirmationError(false);
      } else {
        prescriptionModule._confirmationError(true);
      }
    });
  },

  _onFormSubmit: function() {
    let items = []
    let index = 0
    let variantID = $('#prescription_product_variant').val()

    prescriptionModule._addToCartBtnLoader(false);

    if($('#quantity_option_left').val() != 0) {
      const item = {}
      const prescriptionProperties = {};

      prescriptionProperties['Eye'] = 'Left'
      prescriptionProperties['Power'] = $('#select_power_left').val()
      prescriptionProperties['Prescription'] = $('.prescription-upload-input')[0].files[0]

      item.id = variantID;
      item.quantity = $('#quantity_option_left').val();
      item.properties = prescriptionProperties;

      items[index] = item

      index += 1
    }

    if($('#quantity_option_right').val() != 0) {
      const item = {}
      const prescriptionProperties = {};

      prescriptionProperties['Eye'] = 'Right'
      prescriptionProperties['Power'] = $('#select_power_right').val()
      prescriptionProperties['Prescription'] = $('.prescription-upload-input')[0].files[0]

      item.id = variantID;
      item.quantity = $('#quantity_option_right').val();
      item.properties = prescriptionProperties;

      items[index] = item
    }

    this._addToCart(items)

  },

  _addToCart: function(items) {
    
    const formData = new FormData();
    
    $.each(items, function(index, item) {
      if(item != undefined) {
        formData.append('items['+index+'][id]', items[index].id);
        formData.append('items['+index+'][quantity]', items[index].quantity);
        formData.append('items['+index+'][properties][Eye]', items[index].properties['Eye']);
        formData.append('items['+index+'][properties][Power]', items[index].properties['Power']);
  
        if($('.prescription-upload-input')[0].files.length > 0) {
          formData.append('items['+index+'][properties][Prescription]', items[index].properties['Prescription']);
        }
  
        //Subscription Plan
        if($('input[name="selling_plan"]').length > 0 && $('input[name="selling_plan"]').val() != '') {
          formData.append('items['+index+'][selling_plan]', $('input[name="selling_plan"]').val());
        }
      }
    })

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData
    })
    .then(response => {
      return response.json();
    })
    .then((json) => {
      	prescriptionModule._onAddToCartSuccess();
        prescriptionModule._addToCartBtnLoader(true);
      
        if(json.message == "Cart Error") {
          $('.product-form__error-messages p').html(json.description);
        }
    })
    .catch((error) => {
      console.error('Error:', error);
      
      prescriptionModule._addToCartBtnLoader(true)
    });
  },
  
  _onAddToCartSuccess: function() {
    prescriptionModule._addToCartBtnLoader(true);

  	fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        cartDrawer._addItems(cart);
        cartDrawer._open();
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
  },
  
  _addToCartBtnLoader: function(bool) {
  	if(bool) {
      $('.prescription-module-wrapper .product-form__submit').attr('disabled');
      $('.prescription-module-wrapper .product-form__submit').removeClass('loading');
	  }
    else {
      $('.prescription-module-wrapper .product-form__submit').removeAttr('disabled');
      $('.prescription-module-wrapper .product-form__submit').addClass('loading');
    }
  },

  _confirmationError: function(error) {
    if(error) {
      $('.product-form__error-messages p').html('Please confirm your prescription.')
      $(".prescription-confirmation-checkbox-label .prescription-confirmation-checkbox-checkmark").addClass('error')
    }
    else {
      $('.product-form__error-messages p').html(' ')
      $(".prescription-confirmation-checkbox-label .prescription-confirmation-checkbox-checkmark").removeClass('error')
    }
  },

  _onNormalProductSubmit: function($form, $button) {
    const formData = new FormData($form[0]);

    $button.addClass('loading').attr('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(json) {
      $button.removeClass('loading').removeAttr('disabled');

      if (json.message == "Cart Error") {
        $('.product-form__error-messages p').html(json.description);
        return;
      }

      prescriptionModule._onAddToCartSuccess();
    })
    .catch(function(error) {
      console.error('Error:', error);
      $button.removeClass('loading').removeAttr('disabled');
    });
  }

}